/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bz3DFinalResult } from './bz3DFinalResult';


export interface Bz3DClientAsyncResponse {
    estimation_in_sec?: string;
    queue_url?: string;
    result?: Bz3DFinalResult;
    status?: string;
    task_id?: string;
}

